import { render, staticRenderFns } from "./PartnerLogo.vue?vue&type=template&id=10df70ca&scoped=true&"
import script from "./PartnerLogo.vue?vue&type=script&lang=ts&"
export * from "./PartnerLogo.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerLogo.vue?vue&type=style&index=0&id=10df70ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df70ca",
  null
  
)

export default component.exports